import { combineReducers } from 'redux'
import user from './user'
import admin from './admin'
import compCtrl from './compCtrl'
import shopOpenTime from './shopOpenTime'

const rootReducer = combineReducers({
  user,
  admin,
  compCtrl,
  shopOpenTime,
})

export default rootReducer
